import { Component } from '@angular/core';

@Component({
  selector: 'cc-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'bbog-cc-allies-web-ui';
}
